import { AxiosError, type AxiosResponse } from 'axios'

import { type RunTestEndpointResponse } from 'queries/external-integrations/types'
import { isValidStatusCodeOrRange } from 'utils/team-external-integrations/team-external-integrations-util'

// equivalent of 50Kb
export const STATUS_CHECK_PAYLOAD_MAX_CONTENT_LENGTH = 51_200

/**
 * Throws an AxiosError with response details if the monitor URL is unreachable or returns a bad status code.
 */
export function throwIfBadResponseForRunTestEndpoint(
  response: AxiosResponse<string | RunTestEndpointResponse>
) {
  const { data } = response
  const { errorMessage, testEndpointResponse } =
    typeof data !== 'string' ? data : {}
  const { responseBody: _, ...endpointResponse } = testEndpointResponse ?? {}
  const { httpStatusCode } = endpointResponse ?? {}

  if (!errorMessage && isValidStatusCodeOrRange(httpStatusCode)) return

  const axiosError = new AxiosError(
    errorMessage,
    `${httpStatusCode ?? response.status}`,
    response.config,
    response.request,
    { ...response, data: endpointResponse }
  )

  axiosError.cause = 'Bad Response'

  throw axiosError
}

/**
 * Throws an AxiosError with response details if the monitor response body evaluation has failed predicates.
 */
export function throwIfFailedPredicateForRunTestEndpoint(
  response: AxiosResponse<RunTestEndpointResponse>
) {
  const { testEndpointResponse, testEvaluationResults } = response.data
  const { responseBodyResults } = testEvaluationResults ?? {}
  const { error } = responseBodyResults ?? {}
  const { httpStatusCode } = testEndpointResponse ?? {}

  if (!error) return

  const axiosError = new AxiosError(
    error,
    `${httpStatusCode ?? response.status}`,
    response.config,
    response.request,
    response
  )

  axiosError.cause = 'Failed Predicate'

  throw axiosError
}
